import { render, staticRenderFns } from "./BalanceRequests.vue?vue&type=template&id=43e5c0da"
import script from "./BalanceRequests.vue?vue&type=script&lang=js"
export * from "./BalanceRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports